<!--
 * @Description: 修改课件
 * @Author: PF
 * @Date: 2024-01-10 09:13:26
 * @LastEditors: PF
 * @LastEditTime: 2025-06-18 16:48:17
-->
<template>
  <div class="insert_page">
    <el-dialog class="w800 h700" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改课件</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="80px" class="demo-ruleForm" status-icon>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期:">
              <span>{{ruleForm.xqmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程:">
              {{ruleForm.kcmc}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周次:">
              <span>第{{ruleForm.zc}}周</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="班级/节次:" class="bjjc">
              <el-row>
                <el-col :span="12">
                  <div style="width:300px">
                    <span>{{ruleForm.bjmc}}/星期{{week[ruleForm.xq]}}第{{ruleForm.jc}}节</span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openEditJiaoXueDanYuan=true;row={kcid:kcid,kcmc:bjlist[0].kcmc}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openEditJiaoXueNeiRong=true;row={kcid:kcid,kcmc:bjlist[0].kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传视频">
              <el-upload class="upload-demo" style="width:100%;" :show-file-list="false" drag :http-request="importspClick">
                <el-icon class="el-icon--upload">
                  <upload-filled />
                </el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或 <em>点击上传</em>
                </div>
              </el-upload>
              <div class="fujian" v-for="(item,index) in sps" :key="item.showPath">
                <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                <el-link @click="shipindel(index)"><span class="iconfont icon-shanchu"></span></el-link>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" prop="fj">
              <el-upload style="width:100%" class="upload-demo" drag :show-file-list="false" accept=".pdf" :http-request="importClick">
                <el-icon class="el-icon--upload">
                  <upload-filled />
                </el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或 <em>点击上传</em>
                </div>
              </el-upload>
              <div class="fujian" v-for="(item,index) in fjs" :key="item.showPath">
                <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                <el-link @click="fuJianDel(index)"><span class="iconfont icon-shanchu"></span></el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span>
          <el-button type="primary" @click="submit()">保存 </el-button>
          <el-button type="primary" @click="submitTj()">保存并提交</el-button>
          <el-button @click="handleClose">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
  <jiaoxuedanyuan v-if="openEditJiaoXueDanYuan" v-model:openEdit="openEditJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openEditJiaoXueNeiRong" v-model:openEdit="openEditJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { successPrompt } from '@/utils/promptInfo'
import { UploadFilled } from '@element-plus/icons-vue'
import { uploadV2 } from '@/api/publicApi'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import { closeWindow, loadSelect, actionPost, submitEditForm } from '@/api/common.js'
const props = defineProps({
  openEdit: {
    type: Boolean,
    required: true
  },
  row: {
    type: Object,
    required: false
  }
})
const ruleFormRef = ref(null)
const ruleForm = ref({})
const bjlist = ref()
// const jxsjmb = ref()// 模板内容
const baseurl = ref(process.env.VUE_APP_BASE_API)
const xqid = ref()
const xqmc = ref()
const kcid = ref()
const kcmc = ref()
const zc = ref()
const fjs = ref([]) // 附件
const sps = ref([]) // 视频
const jxnrData = ref([])
const jxdyData = ref([])
const openEditJiaoXueDanYuan = ref() // 添加教学单元
const openEditJiaoXueNeiRong = ref() // 添加教学内容
const row = ref()
const emits = defineEmits(['update:openEdit', 'ReturnData'])

const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
// 选择课程
const keChengChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: {
      kcid: ruleForm.value.kcid,
      order: 'sx',
      sort: 'asc'
    }
  })
}
// 选择教学单元
const danDuanChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}
// 删除视频
const shipindel = (ind) => {
  sps.value.splice(ind, 1)
}
// 删除附件
const fuJianDel = (ind) => {
  fjs.value.splice(ind, 1)
}

// 关闭
const handleClose = () => {
  emits('update:openEdit', false)
}
// 上传视频
const importspClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'jiaoxveshejikejian') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData)
    .then((res) => {
      const obj = {
        oldname: res.data.ymc,
        showPath: res.data.lj + res.data.mc,
        id: res.data.id
      }
      sps.value.push(obj)
      successPrompt('上传成功')
    })
    .catch()
}
// 上传文件
const importClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'jiaoxveshejikejian') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData)
    .then((res) => {
      const obj = {
        oldname: res.data.ymc,
        showPath: res.data.lj + res.data.mc,
        id: res.data.id
      }
      fjs.value.push(obj)
      successPrompt('上传成功')
    })
    .catch()
}
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      actionPost({ url: '/api/v2/jiaowu/jiaowukejian/' + props.row.kjid, data: {} }).then(res => {
        if (res.code === 200) {
          ruleForm.value = res.data
          danDuanChange()
          sps.value = res.data.listShiPin ? res.data.listShiPin.map(item => ({ id: item.id, showPath: item.fj, oldname: item.ymc })) : []
          fjs.value = res.data.listFuJian ? res.data.listFuJian.map(item => ({ id: item.id, showPath: item.fj, oldname: item.ymc })) : []
          keChengChange()
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 保存
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    id: ruleForm.value.id,
    kbid: props.row.id,
    xqid: props.row.xqid,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    listFj: [
      {
        fjlx: 1,
        fjs: sps.value.map((item) => {
          return item.showPath
        })
      },
      {
        fjlx: 2,
        fjs: fjs.value.map((item) => {
          return item.showPath
        })
      }
    ],
    zc: props.row.zc,
    bjid: ruleForm.value.bjid,
    jc: ruleForm.value.jc,
    kcid: ruleForm.value.kcid,
    xq: ruleForm.value.xq,
    dbgzid: props.row.id,
    jxsjbjcks: [{
      kbid: props.row.id,
      bjid: ruleForm.value.bjid,
      jc: ruleForm.value.jc,
      kcid: ruleForm.value.kcid,
      xq: ruleForm.value.xq
    }],
    zt: 0
  }
  submitEditForm({
    url: '/api/v2/jiaowu/jiaowukejian',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: data,
    callback: function () {
      ruleForm.value = {}
      sps.value = []
      fjs.value = []
      closeWindow('openEdit', emits, true)
    }
  })
}
// 保存并提交
const submitTj = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    id: ruleForm.value.id,
    kbid: props.row.id,
    xqid: props.row.xqid,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    listFj: [
      {
        fjlx: 1,
        fjs: sps.value.map((item) => {
          return item.showPath
        })
      },
      {
        fjlx: 2,
        fjs: fjs.value.map((item) => {
          return item.showPath
        })
      }
    ],
    zc: props.row.zc,
    bjid: ruleForm.value.bjid,
    jc: ruleForm.value.jc,
    kcid: ruleForm.value.kcid,
    xq: ruleForm.value.xq,
    dbgzid: props.row.id,
    jxsjbjcks: [{
      kbid: props.row.id,
      bjid: ruleForm.value.bjid,
      jc: ruleForm.value.jc,
      kcid: ruleForm.value.kcid,
      xq: ruleForm.value.xq
    }],
    zt: 1
  }
  submitEditForm({
    url: '/api/v2/jiaowu/jiaowukejian',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: data,
    callback: function () {
      ruleForm.value = {}
      sps.value = []
      fjs.value = []
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
<style lang="less" scoped>
.fujian {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.bjjc {
  width: 100%;
}
</style>
